import { Component, OnInit } from '@angular/core';
import { RestService } from '../rest.service';

@Component({
  selector: 'app-estadisticas-everis',
  templateUrl: './estadisticas-everis.component.html',
  styleUrls: ['./estadisticas-everis.component.scss']
})
export class EstadisticasEverisComponent implements OnInit {

  stadistics: any[] = [];
  activos: any[] = [];
  group_entidad: any[] = [];
  registro_estados_fecha: any[] = [];
  registro_fecha: any[] = [];
  tipo_estados: any[] = [];
  total_historico: any[] = [];
  constructor(public rest: RestService) { }

  ngOnInit() {
    this.getEstadisticas();
  }

  getEstadisticas() {
    this.rest.postGetEstadisticas_Everis()
      .subscribe((data) => {
        this.stadistics = data['data'];
        this.activos = data['data']['activos'];
        this.group_entidad = data['data']['group_entidad'];
        this.registro_estados_fecha = data['data']['registro_estados_fecha'];
        this.registro_fecha = data['data']['registro_fecha'];
        this.tipo_estados = data['data']['tipo_estados'];
        this.total_historico = data['data']['total_historico'];
        console.log(this.stadistics);
      });
  }

}
